import { useTheme } from '@mui/material';
import type { Theme } from '@mui/system';

import FacebookIconColored from './svg/facebookIconColored.svg';
import FacebookIconMono from './svg/facebookIconMono.svg';
import { EMlpIconVariant } from './Google';

export interface IFacebookIconProps {
	variant?: EMlpIconVariant;
	size?: number;
}

const getSingleColor = (variant: EMlpIconVariant, theme: Theme): string => {
	switch (variant) {
		case EMlpIconVariant.Primary:
			return theme.palette.primary.main;
		case EMlpIconVariant.PrimaryVariation:
			return theme.palette.solutions[600];
		case EMlpIconVariant.Secondary:
			return theme.palette.neutral.main;
		case EMlpIconVariant.Disabled:
			return theme.palette.solutions[800];
		default:
			return theme.palette.primary.main;
	}
};

export const FacebookIcon = ({
	variant = EMlpIconVariant.BrandColors,
	size = 24,
}: IFacebookIconProps) => {
	const theme = useTheme();

	if (variant === EMlpIconVariant.BrandColors) {
		return (
			<FacebookIconColored
				width={size}
				height={size}
				style={{ display: 'block' }}
			/>
		);
	}

	const color = getSingleColor(variant, theme);
	return (
		<FacebookIconMono
			width={size}
			height={size}
			style={{ display: 'block' }}
			fill={color}
		/>
	);
};
